// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingPanelHeading_root__2JyjR","headingSpacing":"EditListingPanelHeading_headingSpacing__2hm0I"};